import { FULL_PLANNER_MODULES } from "./modules";
import type { AuthSession, OnboardingDraft } from "./types";

function defaultTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Karachi";
  } catch {
    return "Asia/Karachi";
  }
}

export function createEmptyOnboardingDraft(session?: AuthSession | null): OnboardingDraft {
  return {
    planTier: "full",
    selectedModules: FULL_PLANNER_MODULES,
    personName: session?.user.name || "",
    partnerName: "",
    title: "",
    email: session?.user.email || "",
    phone: "",
    country: "",
    city: "",
    additionalCities: [],
    startDate: "",
    endDate: "",
    timezone: defaultTimezone(),
    approximateGuests: 0,
    approximateBudget: undefined,
    traditions: [],
    styles: [],
    events: []
  };
}
